<template>
  <div v-if="anyHomeItem" class="contents">
    <div class="d-flex section-title">
      <img src="@/assets/images/Icon ionic-md-home-big.png" alt width="27.3" height="25.2" />
      <p class="title">ホーム</p>
    </div>

    <div v-for="(items, index) in groupItems" :key="index" class="row">
      <HomeItem
        v-for="(name, index) in items"
        :key="index"
        :imagePath="getHomeItemByName(name).imagePath"
        :title="getHomeItemByName(name).title"
        :forwardPath="dynamicForwardPath(name)"
      ></HomeItem>
    </div>
  </div>

  <component v-else :is="currentHomePage"></component>
</template>

<script>
import { mapState } from 'vuex';
import { mapGetters } from 'vuex';
import HomeItem from '@/components/home/HomeItem.vue';
import TeacherHome from '@/views/ask_teachers/Index.vue';

export default {
  name: 'Home',
  components: {
    HomeItem,
    TeacherHome,
  },
  computed: {
    currentHomePage() {
      return this.role.currentRole.homePage;
    },
    ...mapState(['role']),
    ...mapGetters('role', ['anyHomeItem', 'groupItems']),
    ...mapGetters('home_item', ['getHomeItemByName']),
  },
  methods: {
    dynamicForwardPath(name) {
      const homeItem = this.getHomeItemByName(name);
      if (this.role.currentRole.inferiorControlItems.includes(name)) {
        this.$logger.debug('Current Role [' + this.role.currentRole.name + '] is superior to this item [' + name + ']');
        return homeItem.superiorForwardPath;
      }
      this.$logger.debug(
        'Current Role [' + this.role.currentRole.name + '] is NOT superior to this item [' + name + ']'
      );
      return homeItem.forwardPath;
    },
  },
};
</script>
